import { ISubmissionDashboardResponse } from '../../../../model/ser/dashboard/response/submission-dashboard-response';
import { PeriodPreset } from '../dashboard-period';

export type DashboardState = {
    preset: PeriodPreset;
    startDate: string;
    endDate: string;
    data?: ISubmissionDashboardResponse;
    loading: boolean;
    error?: string;
};

export enum ACTION_TYPES {
    setPeriod = 'setPeriod',
    loadStart = 'loadStart',
    loadSuccess = 'loadSuccess',
    loadError = 'loadError',
}

export const DashboardReducer = (state: DashboardState, action: any): DashboardState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setPeriod:
            return { ...state, ...payload };
        case ACTION_TYPES.loadStart:
            return { ...state, loading: true, error: undefined };
        case ACTION_TYPES.loadSuccess:
            return { ...state, loading: false, data: payload };
        case ACTION_TYPES.loadError:
            return { ...state, loading: false, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
